module.exports = __webpack_public_path__ + "img/Neo4j.35e593c.svg";